// function pdfjsApplyConfig(iframeEl, linkEl) {
//   var cfg = linkEl.getAttribute('data-pdfjs-config');
//   if (!cfg) return;

//   var parsed = JSON.parse(cfg);
//   if (parsed && parsed.toolbarConfig) {
//     iframeEl.contentWindow.postMessage(parsed.toolbarConfig, '*');
//   }
// }


(function () {
  'use strict';

  function decodeConfigFromLink(linkEl) {
    var enc = linkEl.getAttribute('data-pdfjs-config');
    if (!enc) return null;

    try {
      return JSON.parse(decodeURIComponent(enc));
    } catch (e) {
      console.error('[pdfjs-redactor] config JSON parse failed', e, enc);
      return null;
    }
  }

  function getIframeIdFromLink(linkEl) {
    // Empfohlen: explizites data-attribut (falls du es im Plugin ergänzt)
    var explicit = linkEl.getAttribute('data-pdfjs-iframe-id');
    if (explicit) return explicit;

    // Fallback: aus Link-ID ableiten
    // link id: pdfjs_redactor_<token>
    // iframe id: pdfjs_migxid<token>
    var linkId = linkEl.id || '';
    var token = linkId.replace(/^pdfjs_redactor_/, '');
    if (!token || token === linkId) return null;
    return 'pdfjs_migxid' + token;
  }

  function bindToolbarConfigToIframe(iframeEl, toolbarConfig) {
    if (!iframeEl || !toolbarConfig) return;

    // nicht mehrfach binden
    if (iframeEl.__pdfjsToolbarBound) return;
    iframeEl.__pdfjsToolbarBound = true;

    iframeEl.addEventListener('load', function () {
      try {
        iframeEl.contentWindow.postMessage(toolbarConfig, '*');
      } catch (e) {
        console.error('[pdfjs-redactor] postMessage failed', e);
      }
    });

    // Optional: falls das iframe schon geladen ist, einmal „sofort“ versuchen
    try {
      if (iframeEl.contentWindow && iframeEl.contentDocument && iframeEl.contentDocument.readyState === 'complete') {
        iframeEl.contentWindow.postMessage(toolbarConfig, '*');
      }
    } catch (e2) {
      // ignorieren – kann je nach Browser/Timing zicken
    }
  }

  function ensureGlobalMessageListener() {
    if (window.__pdfjsToolbarConfiguredListener) return;
    window.__pdfjsToolbarConfiguredListener = true;

    window.addEventListener('message', function (e) {
      if (e && e.data && e.data.status === 'toolbarConfigured') {
        console.log('Toolbar erfolgreich konfiguriert');
      }
    });
  }

  /**
   * Hauptfunktion:
   * Übergib den Link (oder Link-ID) und es bindet die Konfiguration an das passende iframe.
   * Wenn das iframe noch nicht existiert, wird kurz gepollt (weil es oft erst beim Öffnen erzeugt wird).
   */
  function applyPdfjsConfigForLink(linkElOrId, opts) {
    opts = opts || {};
    var pollMs = opts.pollMs || 100;
    var maxTries = opts.maxTries || 200; // 20s

    var linkEl = (typeof linkElOrId === 'string')
      ? document.getElementById(linkElOrId)
      : linkElOrId;

    if (!linkEl) return false;

    var cfg = decodeConfigFromLink(linkEl);
    if (!cfg || !cfg.toolbarConfig) return false;

    ensureGlobalMessageListener();

    var iframeId = getIframeIdFromLink(linkEl);
    if (!iframeId) {
      console.error('[pdfjs-redactor] cannot determine iframe id for link', linkEl);
      return false;
    }

    var tries = 0;
    var t = setInterval(function () {
      var iframeEl = document.getElementById(iframeId);
      if (iframeEl) {
        clearInterval(t);
        bindToolbarConfigToIframe(iframeEl, cfg.toolbarConfig);
      } else if (++tries > maxTries) {
        clearInterval(t);
        console.error('[pdfjs-redactor] iframe not found:', iframeId);
      }
    }, pollMs);

    return true;
  }

  // Export (damit deine bestehende Popup-Logik es einfach aufrufen kann)
  window.pdfjsRedactorApplyConfig = applyPdfjsConfigForLink;
})();
